import { withMetadata } from '../min/metadata'

import _isValidNumberForRegion from '../es6/isValidNumberForRegion'

export function isValidNumberForRegion() {
	return withMetadata(_isValidNumberForRegion, arguments)
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/libphonenumber-js/index.es6.exports/isValidNumberForRegion.js
// module id = 645
// module chunks = 0